module.exports = __webpack_public_path__ + "img/雨雪天气.a0da9f75.png";